import { useUnit } from 'effector-react'

import NotFoundIcon from '@/assets/icons/icon-not-found.svg'
import { Page } from '@/components/layout/page/page.tsx'
import { $creatorId, $isCreatorProcessCompleted } from '@/models/creators.ts'
import { $tiers, getTiersListFx } from '@/models/lists/tiers.ts'
import { CreatorNotSelected } from '@/modules/creators/ui/CreatorNotSelected'
import { AddTierDialogButton } from '@/modules/tiers/components/add-tier-dialog-button'
import { TiersTable } from '@/modules/tiers/components/tier-table'
import { TiersPageSkeleton } from '@/modules/tiers/components/tiers-page-skeleton'

export const TierPage = () => {
  const isCreatorProcessCompleted = useUnit($isCreatorProcessCompleted)
  const tiersLoading = useUnit(getTiersListFx.pending)
  const creatorId = useUnit($creatorId)
  const tiers = useUnit($tiers)

  if (!isCreatorProcessCompleted || tiersLoading) {
    return <TiersPageSkeleton />
  }

  if (!creatorId) {
    return (
      <Page title="Fan Spend Lists">
        <CreatorNotSelected />
      </Page>
    )
  }

  if (!tiers.length) {
    return (
      <Page>
        <div className="mt-20 flex h-full w-full flex-col items-center justify-center gap-4">
          <NotFoundIcon />
          <div className="flex flex-col gap-1.5 text-center">
            <h3
              className="text-2xl font-semibold text-text-default"
              data-testid="no-lists-header"
            >
              No Fan Spend Lists
            </h3>
            <p className="text-text-sub">
              Add your fans to lists depending <br /> on their spend
            </p>
          </div>
          <AddTierDialogButton className="min-w-[180px]" />
        </div>
      </Page>
    )
  }

  return (
    <Page
      title="Fan Spend Lists"
      description={
        <span className="flex items-center gap-2">
          Add your fans to lists depending on their spend
        </span>
      }
      headerOptions={<AddTierDialogButton />}
    >
      <TiersTable />
    </Page>
  )
}
